<template>
  <div class="page" :class="[scrollContent ? 'scroll-content' : '']">    
    <PageLeft>
    <template v-slot:page>
        <div ref="content">        
            <div class="all-content">    
                <div class="image"><transition name="fade" mode="out-in" appear><img src="@/assets/images/features_and_amenities/leading-edge-tech.jpg" alt=""></transition></div>                        
                  <div class="page-content content">
                    <transition name="slide-fade" mode="out-in" appear>
                      <TitleContent h2="Features & Amenities" h1="Leading Edge Technology" />
                    </transition>
                    <transition name="slide-fade" mode="out-in" appear>
                      <div class="text-content">                      
                        <p class='large yellow'>The most connected stadium in North America</p>
                        <p>Allegiant Stadium features 1,700 Wi-Fi 6 access points backed by redundant 40-gigabit optical internet connections, providing ample bandwidth for every mobile device in the 65,000-seat stadium.</p>                        
                      </div>                    
                    </transition>
                  </div>                
            </div>
        </div>
    </template>
    </PageLeft>    
  </div>
</template>

<script>
import PageLeft from "@/patterns/PageLeft.vue";
import TitleContent from "@/patterns/TitleContent.vue";
export default {
  name: "TheStadium",
  components: { PageLeft, TitleContent },
  data: () => ({
    scrollContent: false,    
  }),  
  mounted() {
    window.addEventListener("resize", this.shouldScrollContent);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.shouldScrollContent);
  },
  methods: {
    shouldScrollContent() {
      this.scrollContent =
        this.$refs.content.clientHeight > window.innerHeight ? true : false;
    },
  },
};
</script>